import { Routes } from '@angular/router';
import { ASFGuard } from './core/guards/asf-guard.service';
import { CPGuard } from './core/guards/cp-guard.service';
import { RedirectionGuardService } from './core/guards/redirection-guard.service';
import { LoginByNonceGuardService } from './core/guards/login-by-nonce-guard.service';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [RedirectionGuardService],
  },
  {
    path: 'login/:nonceId',
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginByNonceGuardService, RedirectionGuardService],
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./components/search-asf/search-asf.component').then(m => m.SearchAsfComponent),
    canActivate: [ASFGuard],
  },
  {
    path: 'mycontracts',
    loadComponent: () =>
      import('./components/mycontracts-cp/mycontracts-cp.component').then(
        m => m.MycontractsCpComponent
      ),
    canActivate: [CPGuard],
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
